module.exports = __webpack_public_path__ + "img/tv.fba0305b.svg";